module.exports = __webpack_public_path__ + "static/media/slideshow-product.d2a16495.jpg";